import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateSkillCollectionVersionQueries } from "./cache-utils";

import { ENDPOINTS } from "@/api/application-api";
import { useAuth } from "@/context/auth-context";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

interface CreateSkillCollectionLabelParams {
  workspaceId: number;
  collectionId: string;
  name: string;
  versionId: string;
}

export const useCreateSkillCollectionLabel = () => {
  const auth = useAuth();
  const userToken = auth?.userToken ?? "";
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      workspaceId,
      collectionId,
      name,
      versionId,
    }: CreateSkillCollectionLabelParams) => {
      const res = await fetch(ENDPOINTS.skill_collections.labels(workspaceId, collectionId), {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          skill_collection_id: collectionId,
          name,
          skill_collection_version_id: versionId,
        }),
      });
      return handleResponse(res);
    },
    onSuccess: (_, variables) => {
      invalidateSkillCollectionVersionQueries(queryClient, variables);
    },
  });
};
